import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { forgotPassword } from '../api'; // Предполагаемая функция в api.ts
import HCaptcha from '@hcaptcha/react-hcaptcha';
import styles from './HomePage.module.css';

const ForgotPasswordPage: React.FC = () => {
    const navigate = useNavigate();
    const [email, setEmail] = useState<string>('');
    const [error, setError] = useState<string | null>(null);
    const [message, setMessage] = useState<string | null>(null);
    const [hcaptchaToken, setHcaptchaToken] = useState<string | null>(null);

    const navigateToSection = (sectionId: string): void => {
        navigate(`/#${sectionId}`);
    };

    const startNewChat = (): void => {
        navigate('/chat');
    };

    const handleForgotPassword = async (e: React.FormEvent<HTMLFormElement>): Promise<void> => {
        e.preventDefault();
        if (!hcaptchaToken) {
            setError('Пожалуйста, пройдите проверку hCaptcha.');
            return;
        }
        try {
            const response = await forgotPassword(email, hcaptchaToken); // Передаем email и hCaptcha токен
            if (response.success) {
                setMessage('Код для сброса пароля отправлен на ваш email.');
                setError(null);
                setTimeout(() => navigate('/reset-password', { state: { email } }), 2000);
            } else {
                setError(response.message || 'Ошибка при запросе сброса пароля');
            }
        } catch (err: any) {
            setError(err.response?.data?.error || 'Ошибка при запросе сброса пароля');
        }
    };

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className={styles.homeContainer}>
            <header className={styles.homeHeader}>
                <div className={styles.container}>
                    <div className={styles.headerContent}>
                        <div className={styles.homeLogo}>
                            <h1>
                                GPT4Chats<span>.</span>
                            </h1>
                        </div>
                        <nav className={styles.homeNav}>
                            <button className={styles.navLink} onClick={() => navigateToSection('hero')}>
                                Главная
                            </button>
                            <button className={styles.navLink} onClick={() => navigateToSection('features')}>
                                Особенности
                            </button>
                            <button className={styles.navLink} onClick={() => navigateToSection('faq')}>
                                Вопросы
                            </button>
                            <button className={styles.startChatBtnSmall} onClick={startNewChat}>
                                Начать
                            </button>
                        </nav>
                    </div>
                </div>
            </header>

            <section className={styles.authSection}>
                <div className={styles.authContainer}>
                    <h1>Сброс пароля</h1>
                    <p className={styles.authIntro}>
                        Введите ваш email, чтобы получить код для сброса пароля.
                    </p>
                    <form onSubmit={handleForgotPassword} className={styles.authForm}>
                        <div>
                            <label htmlFor="email">Email</label>
                            <input
                                type="email"
                                id="email"
                                value={email}
                                onChange={(e: React.ChangeEvent<HTMLInputElement>) => setEmail(e.target.value)}
                                required
                                className={styles.authInput}
                                placeholder="Введите ваш email"
                            />
                        </div>

                        
                        {error && <p className={styles.authError}>{error}</p>}
                        {message && <p className={styles.authIntro}>{message}</p>}
                        <button type="submit" className={styles.authButton}>
                            Получить код
                        </button>
                    </form>
                    <div className={styles.policyFooter}>
                        <button className={styles.authLink} onClick={() => navigate('/login')}>
                            Вернуться к входу
                        </button>
                        <span className={styles.authSep}>•</span>
                        <button className={styles.authLink} onClick={() => navigate('/register')}>
                            Регистрация
                        </button>
                        <span className={styles.authSep}>•</span>
                        <button className={styles.authLink} onClick={() => navigate('/')}>
                            На главную
                        </button>
                    </div>
                </div>
            </section>

            <footer className={styles.homeFooter}>
                <div className={styles.container}>
                    <div className={styles.footerContent}>
                        <div className={styles.footerSection}>
                            <h4>
                                GPT4Chats<span>.</span>
                            </h4>
                            <p>Ваш ИИ-помощник для работы и творчества.</p>
                            <p>GPT4Chats.ru</p>
                        </div>
                        <div className={styles.footerSection}>
                            <h4>Навигация</h4>
                            <button className={styles.navLink} onClick={() => navigateToSection('hero')}>
                                Главная
                            </button>
                            <button className={styles.navLink} onClick={() => navigateToSection('features')}>
                                Особенности
                            </button>
                            <button className={styles.navLink} onClick={() => navigateToSection('faq')}>
                                Вопросы
                            </button>
                        </div>
                        <div className={styles.footerSection}>
                            <h4>Документы</h4>
                            <button className={styles.navLink} onClick={() => navigate('/privacy-policy')}>
                                Политика конфиденциальности
                            </button>
                            <button className={styles.navLink} onClick={() => navigate('/terms-of-use')}>
                                Условия использования
                            </button>
                        </div>
                        <div className={styles.footerSection}>
                            <h4>Контакты</h4>
                            <p>Email: support@gpt4chats.ru</p>
                        </div>
                    </div>
                    <div className={styles.footerBottom}>
                        <p>© {new Date().getFullYear()} GPT4Chats. Все права защищены.</p>
                    </div>
                </div>
            </footer>
        </div>
    );
};

export default ForgotPasswordPage;